import { adminConstants } from '../constants';
import { adminService } from '../services';
import { showToast } from '../services/toast';

export const adminActions = {
    fetchAdmins,
    createAdmin,
    updateAdmin,
    disableAdmin
};

const DUPLICATE_ADMIN_MESSAGE_RE = /already exists|already in use|duplicate/i;

const buildDuplicateAdminError = (message) => {
    const err = new Error(message);
    err.errorMessage = message;
    err.alreadyShownToast = true;
    err.toastType = 'warn';
    return err;
};

function fetchAdmins(signal) {
    return dispatch => {
        dispatch(request());

        adminService.fetchAdminsList(signal)
            .then(
                response => {
                    dispatch(success(response.data));
                    return response;
                },
                error => {
                    if (error?.code === 'ERR_CANCELED' || error?.name === 'Canceled') return;
                    dispatch(failure(error));
                    if (!error?.alreadyShownToast) showToast(error?.message || error.toString(), 'error');
                }
            );
    };

    function request() { return { type: adminConstants.FETCH_ADMINS_REQUEST } }
    function success(admins) { return { type: adminConstants.FETCH_ADMINS_SUCCESS, admins } }
    function failure(error) { return { type: adminConstants.FETCH_ADMINS_FAILURE, error } }
}

function createAdmin(adminDetails) {
    return dispatch => {
        dispatch(request());

        return adminService.createAdmin(adminDetails)
            .then(
                response => {
                    const businessMessage = response?.responseMessage || response?.errorMessage || response?.message || '';
                    if (DUPLICATE_ADMIN_MESSAGE_RE.test(businessMessage)) {
                        return Promise.reject(buildDuplicateAdminError(businessMessage));
                    }

                    dispatch(createAdminSuccess());
                    showToast(response?.responseMessage || 'Admin created successfully', 'success');
                    return dispatch(fetchAdmins());
                },
                error => {
                    dispatch(failure(error.toString()));
                    const toastType = error?.toastType || 'error';
                    error.alreadyShownToast = true;
                    showToast(error?.errorMessage || error?.message || error.toString(), toastType);
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: adminConstants.CREATE_ADMIN_REQUEST } }
    function createAdminSuccess(admin) { return { type: adminConstants.CREATE_ADMIN_SUCCESS, admin } }
    function failure(error) { return { type: adminConstants.CREATE_ADMIN_FAILURE, error } }
}

function updateAdmin(adminDetails) {

    return dispatch => {
        dispatch(request());

        return adminService.updateAdmin(adminDetails)
            .then(
                response => {
                    const businessMessage = response?.responseMessage || response?.errorMessage || response?.message || '';
                    if (DUPLICATE_ADMIN_MESSAGE_RE.test(businessMessage)) {
                        return Promise.reject(buildDuplicateAdminError(businessMessage));
                    }

                    dispatch(success(response.data));
                    showToast(response.responseMessage, 'success');
                },
                error => {
                    dispatch(failure(error));
                    const toastType = error?.toastType || 'error';
                    error.alreadyShownToast = true;
                    showToast(error?.errorMessage || error?.message || error.toString(), toastType);
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: adminConstants.UPDATE_ADMIN_REQUEST } }
    function success(admins) { return { type: adminConstants.UPDATE_ADMIN_SUCCESS, admins } }
    function failure(error) { return { type: adminConstants.UPDATE_ADMIN_FAILURE, error } }

}

function disableAdmin(adminId) {

    return dispatch => {
        dispatch(request());
        
        return adminService.disableAdmin(adminId)
            .then(
                (response) => {
                    dispatch(success(adminId));
                    showToast(response.responseMessage, 'success');
                    return response;
                },
                error => {
                    dispatch(failure(error));
                    const deleteMessage = error?.errorMessage || error?.message || 'Error deleting admin';
                    if (!error?.alreadyShownToast) {
                        error.alreadyShownToast = true;
                        showToast(deleteMessage, 'error');
                    }
                    return Promise.reject(error);
                }
            );
    };

    function request() { return { type: adminConstants.DISABLE_ADMIN_REQUEST } }
    function success(id) { return { type: adminConstants.DISABLE_ADMIN_SUCCESS, payload: id } }
    function failure(error) { return { type: adminConstants.DISABLE_ADMIN_FAILURE, error } }
}
